export default "__VITE_ASSET__DanTsgX$__"